import { useQuery } from "urql"

import { GetAvailableAlternatesDocument, type GetAvailableAlternatesQuery } from "@/graphql/codegen/graphql"

export type AvailableAlternateItem = Extract<
  GetAvailableAlternatesQuery["companyProductAssociation"]["getAvailableAlternates"],
  { __typename: "GetAvailableAlternatesSuccess" }
>["availableLocations"][number]

interface UseGetAvailableAlternatesParams {
  companyProductAssociationLocationId: string
  searchTerm?: string
  pause?: boolean
}

interface UseGetAvailableAlternatesReturn {
  availableAlternates: AvailableAlternateItem[]
  isFetching: boolean
}

export const useGetAvailableAlternates = ({
  companyProductAssociationLocationId,
  searchTerm,
  pause,
}: UseGetAvailableAlternatesParams): UseGetAvailableAlternatesReturn => {
  const [{ data, fetching }] = useQuery({
    query: GetAvailableAlternatesDocument,
    variables: { companyProductAssociationLocationId, searchTerm },
    pause,
  })

  const result = data?.companyProductAssociation?.getAvailableAlternates
  const availableAlternates = result?.__typename === "GetAvailableAlternatesSuccess" ? result.availableLocations : []

  return { availableAlternates, isFetching: fetching }
}
